import { Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { IUsuario } from '@appNeo/neoCore/interfaces/IUsuario';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs';

@Component({
  selector: 'neo-menu-user',
  templateUrl: './menu-user.component.html',
  styleUrls: ['./menu-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuUserComponent implements OnInit {
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  usuarioConectado : IUsuario = null;
  ADMIN_REGISTRO_FRONT: boolean = false;

  @Input() comprobarAccion = true;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  desencadenarAccion: boolean = !environment.proximamente_reservas;

  constructor(
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
  }

  logout() {}

  accederAreaCliente() {
    if (this.comprobarAccion) {
      this.validarAccion();
    } else {
      this.accion();
    }
  }


  validarAccion() {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion();
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }

  accion() {
    if (this.desencadenarAccion) {
      this.router.navigate(['/areaCliente/informacion-reserva']);
    } else {
      this.mostrarProximamente();
    }
  }
  mostrarProximamente() {
    this.accionesDialogoProximamente.first.abrirDialogo();
  }

}
